import templateUrl from "emun.auth/accept-vendor-terms-prompt.htm";
import controller from "emun.auth/accept-vendor-terms-prompt.controller";
import open from "webmodals/open";
import scss from 'emun.auth/accept-terms-prompt.client.scss';

export default ({
	size = "md accept-terms-prompt",
	backdrop = "static",
	placement = "center",
	preventAutoHeight = true,
	retailer = {},
	title = "Terms of Service",
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		resolve: {
			preventAutoHeight: () => preventAutoHeight,
			title: () => title,
			retailer: () => retailer
		},
		bindToController: true,
		controllerAs: "$ctrl"
	}).result;
